export const environment = {
  production: true,
  wwwUrl: 'https://admin2.tmnz.co.nz',
  apiUrl: 'https://apiadmin2.tmnz.co.nz',
  hmr: false,
  test: false,
  environmentName: 'production',
  tportal: true,
};
